'use strict'

const ContactType = {
  'MASTER_USER': {'value': 1, 'string_value': 'Master user'},
  'TRADE_SETTLEMENT_MANAGER': {'value': 2, 'string_value': 'Trade Settlement Manager'},
  'ALT_TRADE_SETTLEMENT_CONTACT': {'value': 3, 'string_value': 'Alternative Trade Settlement Contact'},
  'CREDIT_DEPARTAMENT_CONTACT': {'value': 4, 'string_value': 'Credit department contact'},
  'ALT_CREDIT_DEPARTAMENT_CONTACT': {'value': 5, 'string_value': 'Alternative credit department contact'},
  'TRADER': {'value': 6, 'string_value': 'Trader'},
  'VIEWER_ONLY': {'value': 0, 'string_value': 'Viewer only'}
}

const CompanyFunction = {
  'EXECUTIVE_MANAGEMENT': {'value': 1, 'string_value': 'Executive management'},
  'OWNER': {'value': 2, 'string_value': 'Owner'},
  'SALES_AND_MARKETING': {'value': 3, 'string_value': 'Sales and marketing'},
  'PROCUREMENT': {'value': 4, 'string_value': 'Procurement'},
  'PRODUCTION': {'value': 5, 'string_value': 'Production'},
  'BROKER': {'value': 6, 'string_value': 'Broker'}, 
  'INFORMATION_TECHNOLOGY': {'value':7, 'string_value': 'Information Technology'},
  'RESEARCH_AND_DEVELOPMENT': {'value': 8, 'string_value': 'Research and development'},
  'CONSULTANT': {'value': 9, 'string_value': 'Consultant'},
  'OTHER': {'value': 10, 'string_value':  'Other'}
}

module.exports.ContactType = ContactType
module.exports.CompanyFunction = CompanyFunction



//////////////////
// WEBPACK FOOTER
// ../backend/utils/constants.js
// module id = 885
// module chunks = 0